import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'

export const Route = createFileRoute('/_app/loyalty/members')({
  staticData: { crumb: 'loyaltyMembers' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'loyalty.read'),
  component: Outlet,
})
